import * as Yup from 'yup';
import { SarlaftPersonNatural } from '../../../../../../shared/types/modules/sarlaft';

export const initialValues: SarlaftPersonNatural = {
    insuredCode: '',
    age: '',
    typeClient: '',
    ciiu: '',
    placeIssue: '',
    dateIssue: '',
    placeBirth: '',
    dateBirth: '',
    nationality: '',
    occupation: '',
    profession: '',
    company: '',
    area: '',
    charge: '',
    adress: '',
    location: '',
    faxCompany: '',
};

export const validationSchema = (isSalaried: boolean) =>
    Yup.object({
        insuredCode: Yup.string().required(
            'El código asegurado es obligatorio'
        ),
        age: Yup.string().required('La edad es obligatoria'),
        typeClient: Yup.string().required('El tipo cliente es obligatorio'),
        ciiu: Yup.string().required('El ciiu es obligatorio'),
        nationality: Yup.string().required('La nacionalidad es obligatoria'),
        occupation: Yup.string().required(
            'La ocupación u oficio es obligatorio'
        ),
        profession: Yup.string().required('La profesión es obligatoria'),
        company: isSalaried
            ? Yup.string().required('La compañía es obligatoria')
            : Yup.string(),
        area: isSalaried
            ? Yup.string().required('El área es obligatoria')
            : Yup.string(),
        charge: isSalaried
            ? Yup.string().required('El cargo es obligatorio')
            : Yup.string(),
        adress: isSalaried
            ? Yup.string().required('La dirección es obligatoria')
            : Yup.string(),
        location: isSalaried
            ? Yup.string().required('La ubicación es obligatoria')
            : Yup.string(),
        faxCompany: isSalaried
            ? Yup.string().required('El fax de la compañía es obligatorio')
            : Yup.string(),
    });
